import React, { Component, Fragment, memo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import DatePicker from '../../../../../../UI/DatePicker/DatePicker';
import { Obtener_Estatus_Request } from '../../../../../../../request/CallCenterMonitorRequest';
import { ParametroCallCenter_Detalle } from "../../../../../../../request/MantenimientosRequest";

const keySessionDateIni = 'fechaTerminadasIni';
const keySessionDateFin = 'fechaTerminadasFin';

class TabPanelFiltro extends Component {
    _isMounted = false;
    state = {
        fecha_activa_inicio: new Date(),
        fecha_activa_fin: new Date(),
        dias_monitoreo: 5,
        fechasCargadas: false,
        estados: [],
        cargandoEstados: false
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.activo && (this.props.permitirFechasAnteriores || this.props.permitirFechasPosteriores)) {
            this.obtenerParametroDiasMonitoreo();
        }

        if (this.props.activo && this.props.mostrarEstadosExpress) {
            this.obtenerEstados();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.activo && this.props.permitirFechasAnteriores && !this.state.fechasCargadas && this.props.permitirFechasAnteriores !== prevProps.permitirFechasAnteriores) {
            this.obtenerParametroDiasMonitoreo();
        }

        if (this.props.activo && this.props.mostrarEstadosExpress && !this.state.cargandoEstados && (!this.state.estados || this.state.estados.length === 0)) {
            this.obtenerEstados();
        }
    }

    obtenerParametroDiasMonitoreo = async () => {
        if (this.props.token) {
            const response = await ParametroCallCenter_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            if (response) {
                this.setState({ fechasCargadas: true });
                let fecha_activa_inicio = new Date();
                let fecha_activa_fin = new Date();
                const dias_monitoreo = response.ParDiasMonitoreo || 5;

                let minDate = new Date();
                if (this.props.permitirFechasAnteriores) {
                    fecha_activa_inicio.setDate(fecha_activa_inicio.getDate() - (dias_monitoreo >= 5 ? 5 : dias_monitoreo));
                    minDate.setDate(minDate.getDate() - dias_monitoreo);
                    minDate.setHours(0, 0, 0, 0);

                    const sessionDateIni = this.getSessionStorageLastDate(keySessionDateIni);
                    if (sessionDateIni) {

                        const fechaGuardada = new Date(sessionDateIni);
                        if (fechaGuardada >= minDate) {
                            fecha_activa_inicio = fechaGuardada;
                        }
                    }
                }

                let maxDate = new Date();
                if (this.props.permitirFechasPosteriores) {
                    fecha_activa_fin.setDate(fecha_activa_fin.getDate() + response.ParDiasCalendarizadas);
                    maxDate.setMonth(maxDate.getMonth() + 1);
                    maxDate.setHours(23, 59, 59, 0);

                    const sessionDateFin = this.getSessionStorageLastDate(keySessionDateFin);
                    if (sessionDateFin) {

                        const fechaGuardada = new Date(sessionDateFin);
                        if (fechaGuardada <= maxDate) {
                            fecha_activa_fin = fechaGuardada;
                        }
                    }
                }

                this.setSessionStorageLastDate(keySessionDateIni, fecha_activa_inicio.toUTCString());
                this.setSessionStorageLastDate(keySessionDateFin, fecha_activa_fin.toUTCString());
                this._isMounted && this.setState({ dias_monitoreo, fecha_activa_inicio, fecha_activa_fin, maxDate, minDate });
                this.props.onChangeFechaActiva([fecha_activa_inicio, fecha_activa_fin]);
            }
        }
    }

    obtenerEstados = async () => {
        this.setState({ cargandoEstados: true });
        if (this.props.token) {
            const response = await Obtener_Estatus_Request(this.props.token, this.props.empresa.Id);
            if (response.Exitoso) {
                this._isMounted && this.setState({ estados: response.Datos });
                this.props.onChangeEstadoExpress({ target: { value: response.Datos && response.Datos.length > 0 ? response.Datos[0].Estatus_Id : '' } })
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
        this.setState({ cargandoEstados: false });
    }

    setSessionStorageLastDate = (key, value) => {
        if (this.props.permitirFechasAnteriores) {
            sessionStorage.setItem(key, value);
        }
    }

    getSessionStorageLastDate = key => {
        return sessionStorage.getItem(key);
    }

    onChangeDate = (name, dates) => {
        const [start, end] = dates;
        this.setState({ fecha_activa_inicio: start, fecha_activa_fin: end });
        if (end) {
            this.props.onChangeFechaActiva(dates);
            this.setSessionStorageLastDate(keySessionDateIni, start.toUTCString());
            this.setSessionStorageLastDate(keySessionDateFin, end.toUTCString());
        }
    }

    onClickTodayDate = () => {
        const { fecha_activa_inicio, fecha_activa_fin } = this.state;
        const newDate = new Date();
        if (!fecha_activa_inicio || !fecha_activa_fin || !moment.utc(newDate).isSame(moment.utc(this.state.fecha_activa_inicio), 'day') || !moment.utc(newDate).isSame(moment.utc(this.state.fecha_activa_fin), 'day')) {
            this.setState({ fecha_activa_inicio: newDate, fecha_activa_fin: new Date() });
            this.props.onChangeFechaActiva([newDate, new Date()]);
            this.setSessionStorageLastDate(keySessionDateIni, newDate.toUTCString());
            this.setSessionStorageLastDate(keySessionDateFin, newDate.toUTCString());
        }
    }

    checkDates = (pFechaInicio, pFechaFin) => {
        if (!pFechaInicio && pFechaFin) {
            pFechaInicio = pFechaFin;
        }
        else {
            if (pFechaInicio && !pFechaFin) {
                pFechaFin = pFechaInicio;
            }
            else {
                pFechaInicio = new Date();
                pFechaFin = new Date();
            }
        }

        let newDateIni = new Date(pFechaInicio);
        newDateIni.setHours(0, 0, 0, 0);

        let newDateFin = new Date(pFechaFin);
        newDateFin.setHours(23, 59, 59, 0);

        this.setState({ fecha_activa_fin: newDateFin, fecha_activa_inicio: newDateIni });
        this.props.onChangeFechaActiva([newDateIni, newDateFin]);
        this.setSessionStorageLastDate(keySessionDateIni, newDateIni.toUTCString());
        this.setSessionStorageLastDate(keySessionDateFin, newDateFin.toUTCString());
    }

    onClickPreviousDate = () => {
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDateIni = new Date(fecha_inicio);
            newDateIni.setHours(0, 0, 0, 0);

            if ((this.props.permitirFechasAnteriores && newDateIni > this.state.minDate) || newDateIni > currentDate) {
                newDateIni.setDate(newDateIni.getDate() - 1);

                this.setState({ fecha_activa_inicio: newDateIni });
                this.props.onChangeFechaActiva([newDateIni, fecha_final]);
                this.setSessionStorageLastDate(keySessionDateIni, newDateIni.toUTCString());
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    onClickNextDate = () => {
        let currentDate = new Date();
        currentDate.setHours(23, 59, 59, 0);

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDateFin = new Date(fecha_final);
            newDateFin.setHours(23, 59, 59, 0);

            if ((this.props.permitirFechasPosteriores && newDateFin < this.state.maxDate) || newDateFin < currentDate) {
                newDateFin.setDate(newDateFin.getDate() + 1);

                this.setState({ fecha_activa_fin: newDateFin });
                this.props.onChangeFechaActiva([fecha_inicio, newDateFin]);
                this.setSessionStorageLastDate(keySessionDateFin, newDateFin.toUTCString());
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    render() {

        const { estados, maxDate, minDate } = this.state;
        const estadosExpress = estados && estados.length > 0 ? estados.map(estado => (
            <option key={estado.Estatus_Id} value={estado.Estatus_Id}>{estado.Estatus_Nombre}</option>
        )) : null;

        return (
            <div className="filtros-monitor">
                <div className="row">
                    {
                        this.props.sucursales ?
                            <div className="col-auto">
                                <div className="form-group">
                                    <select className="btn dropdown-toggle selectpicker btn-default text-left" data-style="btn-info" name="selectSucursal" onChange={this.props.onChangeSucursal}>
                                        <option value="0">Todas las Sucursales</option>
                                        {this.props.sucursales.map(sucursal => (
                                            <option key={sucursal.Id} value={sucursal.Id}>{sucursal.Nombre}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            : null
                    }
                    {
                        this.props.mostrarEstatus ?
                            <div className="col-auto">
                                <div className="form-group">
                                    <select className="btn dropdown-toggle selectpicker btn-default text-left" data-style="btn-info" name="selectEstatus" onChange={this.props.onChangeEstatus}>
                                        <option value="">Todos los Estatus</option>
                                        <option value="success">A tiempo</option>
                                        <option value="warning">Tiempo Medio</option>
                                        <option value="delay">Retrasadas</option>
                                    </select>
                                </div>
                            </div>
                            : null
                    }
                    {
                        this.props.mostrarEstadosExpress ?
                            <div className="col-auto">
                                <div className="form-group">
                                    <select className="btn dropdown-toggle selectpicker btn-default text-left" data-style="btn-info" name="selectEstatus" onChange={this.props.onChangeEstadoExpress}>
                                        {estadosExpress}
                                    </select>
                                </div>
                            </div>
                            : null
                    }
                    {
                        this.props.mostrarCalendario ?
                            <Fragment>

                                <div className="col-auto">
                                    <button id="btnToday" className="btn btn-secondary" onClick={this.onClickTodayDate}>Hoy</button>
                                </div>
                                <div className="col-auto">
                                    <button id="btnPreviousDay" className="btn btn-primary" onClick={this.onClickPreviousDate}><FontAwesomeIcon icon={faChevronLeft} /></button>
                                </div>
                                <div className="col-auto col-md-2">
                                    <DatePicker name="fecha_activa" value={this.state.fecha_activa_inicio} onChange={this.onChangeDate} props={{
                                        selectsRange: true,
                                        startDate: this.state.fecha_activa_inicio,
                                        endDate: this.state.fecha_activa_fin,
                                        minDate,
                                        maxDate
                                    }} />
                                </div>
                                <div className="col-auto">
                                    <button id="btnNextDay" className="btn btn-primary" onClick={this.onClickNextDate}><FontAwesomeIcon icon={faChevronRight} /></button>
                                </div>
                            </Fragment>
                            : null
                    }
                    {
                        this.props.mostrarBuscar ?
                            <div className="col">
                                <input type="text"
                                    name="txtBuscar"
                                    className="form-control"
                                    placeholder="Buscar"
                                    value={this.props.textoBuscar}
                                    onChange={this.props.onChangeBuscar} />
                            </div>
                            : null
                    }
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(memo(TabPanelFiltro));
